import { Heart, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import type { Product } from "@kineslima/types";
import { formatMoney } from "../lib/format";
import { PrivacyImage } from "./PrivacyImage";

export function ProductCard({ product, compact = false }: { product: Product; compact?: boolean }) {
  const available = product.status !== "OUT_OF_STOCK" && product.stock > 0;
  return (
    <article className={`product-card ${compact ? "compact" : ""}`}>
      <Link to={`/producto/${product.slug}`} className="product-visual" aria-label={`Ver ${product.name}`}>
        <PrivacyImage src={product.image} alt={`Modelo adulta presentando ${product.name}`} showBadge={!compact} />
        {product.compareAtPrice && <span className="sale-pill">-{Math.round((1 - product.price / product.compareAtPrice) * 100)}%</span>}
        {!available && <span className="stock-pill">Agotado</span>}
        <button className="favorite-button" aria-label={`Guardar ${product.name}`} onClick={(event) => event.preventDefault()}><Heart size={18} /></button>
      </Link>
      <div className="product-copy">
        <div className="flex items-center justify-between gap-3"><span className="category-label">{product.category}</span><span className="text-xs text-white/35">{product.colors.length} {product.colors.length === 1 ? "color" : "colores"}</span></div>
        <Link to={`/producto/${product.slug}`}><h3>{product.name}</h3></Link>
        <p>{product.shortDescription}</p>
        <div className="mt-4 flex items-end justify-between gap-3">
          <div><strong>{formatMoney(product.price)}</strong>{product.compareAtPrice && <del>{formatMoney(product.compareAtPrice)}</del>}</div>
          <Link className="card-action" to={`/producto/${product.slug}`} aria-label={`Consultar ${product.name}`}><MessageCircle size={17} /></Link>
        </div>
      </div>
    </article>
  );
}
